let gtmLoaded = false

function addEvent (event) {
  window.dataLayer = window.dataLayer || []

  if (Array.isArray(event)) {
    window.dataLayer.push(...event)
  } else {
    window.dataLayer.push(event)
  }

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[GTM] new event', event)
  }
}

function loadGTM () {
  if (gtmLoaded) {
    return
  }

  if (process.env.NODE_ENV === 'development') {
    // disable stupid gtm in dev environment
    return
  }

  gtmLoaded = true

  // create script tag
  const script = document.createElement('script')
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K92NRBQ'
  script.async = true

  // append script tag
  document.querySelector('head').appendChild(script)

  // initialize dataLayer
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': (new Date()).getTime(),
    event: 'gtm.js'
  })
}

export {
  loadGTM as default,
  addEvent
}
